<template>
  <el-dialog
    title="请完善真实姓名"
    :visible.sync="innerVisible"
    width="420px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="forced-display-name-dialog"
    @closed="onClosed"
  >
    <p class="forced-dn-hint">
      根据公司要求，登录后须使用<strong>本人真实姓名（须为中文汉字，至少两个汉字）</strong>作为系统显示名；若为字母/数字或其它外文，请改为中文后保存。保存后下次登录不再提示。
    </p>
    <el-form ref="formRef" :model="form" :rules="rules" label-width="88px" size="small" @submit.native.prevent="submit">
      <el-form-item label="用户名">
        <span class="readonly-field">{{ usernameText }}</span>
      </el-form-item>
      <el-form-item label="真实姓名" prop="display_name">
        <el-input
          v-model="form.display_name"
          maxlength="128"
          placeholder="请输入中文姓名，须与本人身份证一致"
          @keyup.enter.native="submit"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="text" class="forced-dn-logout" @click="logout">退出登录</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">保存并继续</el-button>
    </div>
  </el-dialog>
</template>

<script>
import http from '../api/http'
import { clearAuth, getToken, setAuth } from '../auth/session'
import { getChineseDisplayNameValidationError } from '../utils/chineseDisplayName'

function validateChineseDisplayName(rule, value, callback) {
  const v = (value || '').trim()
  if (!v) {
    callback()
    return
  }
  const err = getChineseDisplayNameValidationError(v)
  callback(err ? new Error(err) : undefined)
}

export default {
  name: 'ForcedDisplayNameDialog',
  props: {
    visible: { type: Boolean, default: false },
    user: { type: Object, default: () => null },
  },
  data() {
    return {
      innerVisible: false,
      submitting: false,
      form: { display_name: '' },
      rules: {
        display_name: [
          { required: true, message: '请填写真实姓名', trigger: 'blur' },
          { validator: validateChineseDisplayName, trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    usernameText() {
      const u = this.user
      return u && u.username ? String(u.username) : '—'
    },
  },
  watch: {
    visible(v) {
      this.innerVisible = !!v
      if (v) this.syncFromUser()
    },
    innerVisible(v) {
      this.$emit('update:visible', !!v)
    },
  },
  mounted() {
    this.innerVisible = !!this.visible
    if (this.visible) this.syncFromUser()
  },
  methods: {
    syncFromUser() {
      const u = this.user || {}
      this.form = { display_name: (u.display_name != null ? String(u.display_name) : '').trim() }
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    onClosed() {
      this.syncFromUser()
    },
    async submit() {
      try {
        await this.$refs.formRef.validate()
      } catch (e) {
        return
      }
      this.submitting = true
      try {
        const res = await http.put('/me', {
          display_name: (this.form.display_name || '').trim(),
          acknowledge_real_display_name: true,
        })
        setAuth({ token: getToken(), user: res.data })
        this.$message.success('已保存')
        this.$emit('saved', res.data)
        this.innerVisible = false
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.submitting = false
      }
    },
    async logout() {
      try {
        await http.post('/auth/logout')
      } catch (e) {
        /* 忽略 */
      }
      clearAuth()
      this.innerVisible = false
      this.$router.replace('/login').catch(() => {})
    },
  },
}
</script>

<style scoped>
.forced-dn-hint {
  font-size: 13px;
  color: #606266;
  line-height: 1.55;
  margin: 0 0 16px;
}
.readonly-field {
  color: #606266;
  font-size: 13px;
}
.forced-dn-logout {
  float: left;
  color: #909399;
}
</style>
